import { CodeMaintenanceType } from 'src/constants/nacodemaintenance'
import NaCountryCodeAutocompleteField from './NaCountryCodeAutocompleteField'

function NaFdaEuCountryCodeAutocompleteField(props) {
  return NaCountryCodeAutocompleteField(
    props,
    CodeMaintenanceType.NA_COUNTRY_CODE,
    'eu'
  )
}

export default NaFdaEuCountryCodeAutocompleteField
